import { render, staticRenderFns } from "./VollChat.vue?vue&type=template&id=46c7d5d0&scoped=true"
import script from "./VollChat.vue?vue&type=script&lang=js"
export * from "./VollChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c7d5d0",
  null
  
)

export default component.exports